import { defineStore } from "pinia";
export const useBusyStore = defineStore("busyStore", {
	state: () =>
		({
			count: 0
		}) as { count: number },
	getters: {
		BUSY_COUNT(): any {
			return this.count;
		},
		BUSY_IS(): any {
			return !!this.count;
		}
	},
	actions: {
		BUSY_COUNT_SET(value: number) {
			this.count = value;
		}
	}
});
